<div class="theme-static">
  <section class="header position-fixed w-100">
    <app-common-header></app-common-header>
  </section>

  <!-- End Header Part -->

  <!-- Start Page Header Title Part -->
  <section class="page-header-title">
    <div class="page-title-overlay"></div>
    <img
      src="assets/images/w2c/page-header/faqs.jpg"
      alt=""
      class="w-100 page-title-image"
    />
    <div class="page-header-title-caption">
      <h1>Middle East Conflict Travel Advisory & Updates</h1>
      <!-- <p>World2Cover makes family travel insurance easy! Compare our levels of cover and select the best family travel insurance for you.</p> -->
    </div>
  </section>
  <!-- End Page Ttile  -->

  <!-- Main Content -->
  <main class="page-content py-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="page-content-info">
            <h3>IMPORTANT UPDATE – MIDDLE EAST CONFLICT EFFECTIVE 1ST MARCH 2026</h3>
            <p>
              Due to increased tensions in the Middle East, we advise all travellers to prioritise safety and stay informed.
            </p>
            <p><strong>Travel insurance information</strong></p>
            <ul>
              <li>New travel insurance cover for certain countries in the Middle East cannot be purchased or added to existing policies until further notice.</li>
              <li>Limits, conditions, and exclusions apply. Please check your Product Disclosure Statement and Certificate of Insurance for full details.</li>
              <li>There are general exclusions that apply to any acts of war. There are also general exclusions for locations with ‘Do Not Travel’ warnings. Where these exclusions apply no cover is available. Please refer to your policy documents for details.</li>
            </ul>
            <p><strong>Guidance for travellers</strong></p>
            <p>Stay informed</p>
            <p>Check the latest government travel advice at <a href="https://www.smartraveller.gov.au/" target="_blank">
                www.smartraveller.gov.au</a
              > and monitor airline updates, local media, and emergency services before making travel decisions.</p>
            <p>If you are planning travel to or through the Middle East or neighbouring regions</p>
            <ul>
              <li>Review current travel advisories and ‘Do Not Travel’ warnings.</li>
              <li>Contact your travel provider or agent to confirm your trip and discuss any changes or alternatives.</li>
            </ul>
            <p>If you are currently in the region and require medical assistance</p>
            <p>Contact the 24-hour emergency assistance team on 
              <a href="tel:+61280551683">+61 2 8055 1683</a> for immediate support.</p>
            <p>If you are currently in the region and require assistance with travel plans</p>
            <p>Contact your travel provider or agent to discuss any changes or alternatives.</p>
            <p>If you have booked but not yet departed</p>
            <ul>
              <li>Speak to your travel agent or provider about your options. Changes, credits, or refunds may be available.</li>
              <li>If your trip is affected and you need to make a claim, follow the process outlined here <a
                  target="_blank"
                  [href]="pdsService.getWhiteLabelHref('/how-to-claim', partnerCode)"
                  >How To Claim Travel Insurance Online | World2Cover Australia</a>
                </li>
            </ul>
            <p>For further assistance, please contact the customer service team on <a href="tel:+61292257599"> +61 2 9225 7599</a>.</p>
            <p>We are here to support you. Stay safe and stay informed.</p>
          </div>

          <div class="page-content-info"></div>

          <div class="page-content-info"></div>

          <div class="page-content-info"></div>

          <div class="page-content-info"></div>
        </div>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</div>
